/**
 * Template: Account
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the account page functionality.
 *
 * @namespace account
 */
import '../../../styles/templates/customers/account.scss';
import '../../../styles/templates/customers/activate_account.scss';
import '../../../styles/templates/customers/challenge.scss';
import '../../../styles/templates/customers/reset_password.scss';
import '../../../styles/components/account-nav.scss';



document.addEventListener('DOMContentLoaded', () => {
  if (!localStorage.getItem('loginForm')) {
    return;
  }

  localStorage.removeItem('loginForm');

  window.dataLayer.push({
    event: 'GAevent',
    eventID: '08',
    eventCategory: 'account',
    eventAction: 'login',
    eventLabel: 'step2',
  });
});
